function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("rect", {
  width: 59,
  height: 59,
  fill: "#D69D23",
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M27.3313715,13 L13.724556,13 C13.1722713,13 12.724556,12.5522847 12.724556,12 C12.724556,11.4477153 13.1722713,11 13.724556,11 L28.055061,11 L29.5695643,6.81449371 L11.7309258,6.81449371 C11.1774236,6.81449371 10.7287213,6.36677846 10.7287213,5.81449371 C10.7287213,5.26220896 11.1774236,4.81449371 11.7309258,4.81449371 L30.9969349,4.81449371 C31.6914584,4.81449371 32.175436,5.50227343 31.939581,6.15408633 L27.4189418,18.6473989 C27.2755408,19.0437043 26.8985694,19.3078063 26.4762958,19.3078063 L9.85498473,19.3078063 C9.40860873,19.3078063 9.0160385,19.0132409 8.89215221,18.5853442 L4.09029991,2 L1.00220445,2 C0.448702218,2 -1.0658141e-14,1.55228475 -1.0658141e-14,1 C-1.0658141e-14,0.44771525 0.448702218,0 1.00220445,0 L4.84396246,0 C5.29033847,0 5.68290869,0.294565338 5.80679498,0.722462034 L10.6086473,17.3078063 L25.7726146,17.3078063 L27.3313715,13 Z M12,27 C10.3431458,27 9,25.6568542 9,24 C9,22.3431458 10.3431458,21 12,21 C13.6568542,21 15,22.3431458 15,24 C15,25.6568542 13.6568542,27 12,27 Z M24,27 C22.3431458,27 21,25.6568542 21,24 C21,22.3431458 22.3431458,21 24,21 C25.6568542,21 27,22.3431458 27,24 C27,25.6568542 25.6568542,27 24,27 Z",
  transform: "translate(14 16)"
}));

function SvgIconWebshop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWebshop);
export default __webpack_public_path__ + "static/media/icon-webshop.0cdd86f0.svg";
export { ForwardRef as ReactComponent };